import React from 'react';
import classNames from 'classnames';
import './help-text.scss';

export default function HelpText({ warning = false, ...props }) {
  return (
    <small
      className={classNames('help-text', {
        'help-text--warning': warning,
      })}
      {...props}
    />
  );
}
